













import Vue, { PropType } from "vue"
import CorporationMemberInvitationArea from "./local/myPage/CorporationMemberInvitationArea.vue"
import CEditableDetail from "./local/CEditableDetail.vue"
import { StandardApplicationError } from "~/errorHandlers"
import Container from "~/components/guideline/frame/Container.vue"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"
import { BackendApi } from "~/backendApis"
import {
  UserContactInformationView,
  FullInfoUserProfileView,
} from "~/backendApis/viewModel"

interface DataType {
  isVisibleMenuList: boolean
  currentUserContactInformation: UserContactInformationView | null
}

export default Vue.extend({
  components: {
    Container,
    CorporationMemberInvitationArea,
    CEditableDetail,
  },
  props: {
    /**
     * 表示するプロフィール
     */
    userProfile: {
      type: Object as PropType<FullInfoUserProfileView>,
      required: true,
    },
  },
  data(): DataType {
    return {
      isVisibleMenuList: false,
      currentUserContactInformation: null,
    }
  },
  computed: {
    isAppliableForProject(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.PROJECT_APPLY)
    },
  },
  created() {
    if (this.userProfile.universalUid !== this.$clAuth.userIdOrFail) {
      throw new StandardApplicationError(
        "表示しようとしているプロフィールが認証済みのユーザーのものではありません。"
      )
    }
    this.initializePage()
  },
  methods: {
    initializePage() {
      // 問い合わせ情報を取得
      new BackendApi.User.ExternalNotification.GetMyContactInformationReadRequest()
        .get()
        .then((currentUserContactInformation) => {
          this.currentUserContactInformation = currentUserContactInformation
        })
    },
    async deleteCareer(index: number) {
      if (!confirm("本当にこの経歴・実績を削除してもよろしいですか？")) {
        return
      }

      const currentUserProfile = await new BackendApi.User.UserProfileSearch.GetCurrentUserProfileReadRequest().get()
      if (!currentUserProfile) {
        throw new StandardApplicationError(
          "経歴・実績の更新時にプロフィールデータが存在しません"
        )
      }

      currentUserProfile.career.splice(index, 1)

      await new BackendApi.User.UserProfile.ChangeCareerWriteRequest({
        experienceCorporations: currentUserProfile.career.map((c) => ({
          corporationName: c.corporationName,
          leadingCompanyId: c.leadingCompanyId || null,
          isCurrentCorporation: c.isCurrentCorporation,
          joinReason: c.joinReason || null,
          workSpan: {
            startYear: Number(c.workSpan.startYear),
            startMonth: Number(c.workSpan.startMonth),
            endYear: c.workSpan.endYear ? Number(c.workSpan.endYear) : null,
            endMonth: c.workSpan.endMonth ? Number(c.workSpan.endMonth) : null,
          },
          experienceProjects: c.experiencedProjects.map((p) => ({
            name: p.name,
            personnelScaleId: Number(p.personnelScaleId),
            role: p.role,
            workContent: p.workContent,
            achievedContent: p.achievedContent || null,
            relatedUrl: p.relatedUrl || null,
          })),
        })),
      }).post()

      this.$clStores.flashMessage.actions.drawFlashSuccess(
        "指定された経歴・実績を削除しました"
      )
      this.$clAuth.refreshAuthState()
    },
  },
})
